/**
 * Internal dependencies
 */
import CONTACT_ACTION from '@naruto/bgdcms/src/reducers/cores/contact/events';
import { SetContactContentInitialAction, SetContactInfoAction, ContactInfo } from './types';

/* Initial */
export const SET_CONTACT_INITIALIZE = (): SetContactContentInitialAction => ({
  type: CONTACT_ACTION.SET_CONTACT_INITIALIZE
});

/* Contact Action */
export const SET_CONTACT_INFO = ({ contactInfo }: { contactInfo: ContactInfo }): SetContactInfoAction => ({
  type: CONTACT_ACTION.SET_CONTACT_INFO,
  contactInfo
});
